import { render } from "./collection-filter.vue?vue&type=template&id=290fb2ee"
import script from "./collection-filter.vue?vue&type=script&lang=js"
export * from "./collection-filter.vue?vue&type=script&lang=js"

import "./collection-filter.vue?vue&type=style&index=0&id=290fb2ee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__